(function() {
    'use strict';

    angular.module('process')
        .controller('ProcessStageCreateController', ProcessStageCreateController);

    ProcessStageCreateController.$inject = ['currentProcess', '$uibModalInstance', 'processStageDataSrvc', 'processStageMessagesConst', 'machineDataSrvc', 'productOptionDataSrvc', 'processStageConjunctionsConst', 'notificationSrvc', 'lodashService', 'errorNotificationSrvc'];

    function ProcessStageCreateController(currentProcess, $uibModalInstance, processStageDataSrvc, processStageMessagesConst, machineDataSrvc, productOptionDataSrvc, processStageConjunctionsConst, notificationSrvc, lodashService, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            machine: [],
            machine_action: [],
            description_pl: [],
            description_en: [],
            description_de: [],
            description_cpde: [],
            description_cpen: [],
            time: [],
            preconditions: [getEmptyPreconditionServerError()]
        };
        self.processStageData = {
            machine: undefined,
            machine_action: undefined,
            description_pl: "",
            description_en: "",
            description_de: "",
            description_cpde: "",
            description_cpen: "",
            time: 0.00,
            preconditions: []
        };

        self.machinesChoices = [];
        self.onMachineSelect = onMachineSelect;

        self.machineActionsChoices = [];

        self.conjunctions = processStageConjunctionsConst;
        self.productOptionsChoices = [];
        self.onProductOptionsSearch = onProductOptionsSearch;
        self.isProductOptionsInPreconditions = isProductOptionsInPreconditions;
        self.isProcessStagePreconditions = isProcessStagePreconditions;
        self.addProcessStagePrecondition = addProcessStagePrecondition;
        self.removeProcessStagePrecondition = removeProcessStagePrecondition;

        self.ok = ok;
        self.cancel = cancel;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getMachinesChoices();
            getProductOptionsChoices();
        }

        function getEmptyPreconditionData() {
            return {
                precondition: undefined,
                conjunction: ''
            };
        }

        function getEmptyPreconditionServerError() {
            return {
                precondition: [],
                conjunction: []
            };
        }

        function getMachinesChoices() {
            return machineDataSrvc.forProcessStage()
                .$promise.then(function(response) {
                    self.machinesChoices = response;
                    return response;
                });
        }

        function getProductOptionsChoices() {
            return productOptionDataSrvc.forProcessStage()
                .$promise.then(function(response) {
                    self.productOptionsChoices = response.results;
                    return response;
                });
        }

        function onProductOptionsSearch(params) {
            if (!params) {
                params = {};
            }

            return productOptionDataSrvc.forProcessStage(params).$promise;
        }

        function onMachineSelect(pk) {
            for (var i=0; i<self.machinesChoices.length; i++) {
                if (self.machinesChoices[i].pk === pk) {
                    self.cleanErrors('machine');
                    self.processStageData.machine_action = undefined;
                    self.machineActionsChoices = self.machinesChoices[i].actions;
                    break;
                }
            }
        }

        function isProductOptionsInPreconditions(currentIndex, item) {
            var tmp = self.processStageData.preconditions.filter(
                function(element, index, array) {
                    return element.precondition === item.pk && array[currentIndex].precondition !== item.pk;
                }
            );

            return !tmp.length;
        }

        function isProcessStagePreconditions() {
            return self.processStageData.preconditions.length;
        }

        function addProcessStagePrecondition() {
            self.processStageData.preconditions.push(
                getEmptyPreconditionData());
        }

        function removeProcessStagePrecondition(index) {
            if (self.processStageData.preconditions.length > 1 && index === self.processStageData.preconditions.length - 1) {
                self.processStageData.preconditions[
                    self.processStageData.preconditions.length - 2].conjunction = undefined;
            }

            self.processStageData.preconditions.splice(index, 1);
        }

        function ok() {
            self.processStageData.process = currentProcess.pk;

            processStageDataSrvc.create(
                self.processStageData
            ).$promise.then(
                function(response) {
                    $uibModalInstance.close(response);
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
